import React from "react";
import { Routes, Route } from "react-router-dom";

import AddUser from "../pages/usermanagement/addUser";
import ContentMange from "../pages/contentmanagement/contentmanage";
import CreatePassword from "../pages/createPassword";
import EditUser from "../pages/usermanagement/editUser";
import NotFound from "../pages/NotFound";
import SignIn from "../pages/signin";
import UserManagement from "../pages/usermanagement/userMange";
import ViewUser from "../pages/usermanagement/viewUser";
import ContentUpload from "../pages/contentmanagement/contentupload";
import Client from "../pages/clientmanagement/client";
import Profile from "../pages/profile";
import Company from "../pages/clientmanagement/company/company";
import EditClient from "../pages/clientmanagement/editclient";
import MapContent from "../pages/contentmanagement/mapcontentnew";
import EditContent from "../pages/contentmanagement/editContent";
import ViewClient from "../pages/clientmanagement/viewClient";
import UpdateCompany from "../pages/clientmanagement/company/updateCompany";
import ViewCompany from "../pages/clientmanagement/company/viewCompany";
import Category from "../pages/categorymanagement/category";
import LookUp from "../pages/lookup/lookup";
import EditLookUp from "../pages/lookup/editLookUp";
import ClientSearch from "../pages/reports/clientSearch/clientSearch";
import ViewClientSearch from "../pages/reports/clientSearch/viewClientSearch";
import AllDeals from "../pages/dealmanagement/allDeals";
import Recommend from "../pages/reports/recommended/recommendNew";
import Contact from "../pages/reports/contactus/contactus";
import VideoRequest from "../pages/reports/videoRequests/videoRequest";
import AMReport from "../pages/reports/AMReport/AMReport";
import EditDeals from "../pages/dealmanagement/editDeal";
import BlockBuyer from "../pages/blockBuyer/blockBuyer";
import FrontendSettings from "../pages/frontendSettings/frontendSettings";
import LandingPage from "../pages/frontendSettings/landingPage";
import AdvancedSettings from "../pages/frontendSettings/advancedSettings";
import AppConfig from '../pages/settings/appConfig';
import Privacy from "../pages/frontendSettings/privacy";
import Terms from "../pages/frontendSettings/terms";
import AddDeals from "../pages/dealmanagement/addDeal";
import EditCategory from "../pages/categorymanagement/editCategory";
import ViewContent from "../pages/contentmanagement/viewContent";
import ViewCategory from "../pages/categorymanagement/viewCategory";
import ViewDeals from "../pages/dealmanagement/viewDeals";
import Team from "../pages/frontendSettings/team";
import Aboutus from "../pages/frontendSettings/aboutus";
import ViewLookUp from "../pages/lookup/viewLookup";
import ViewTerms from "../pages/frontendSettings/viewTerms";
import ViewPrivacy from "../pages/frontendSettings/ViewPrivacy";
import ViewTeam from "../pages/frontendSettings/ViewTeam";
import ViewAboutus from "../pages/frontendSettings/ViewAboutus";
import ViewAdvancedSettings from "../pages/frontendSettings/ViewAdvancedSettings";
import ViewLandingPage from "../pages/frontendSettings/ViewLandingPage";
import EditBlockBuyer from "../pages/blockBuyer/editBlockBuyer";
import Changecategoryorder from "../pages/categorymanagement/changeCategoryOrder";
import EmailLogs from "../pages/reports/emailLogs/emailLogs";
import ClientActivity from "../pages/reports/ClientActivity/ClientActivity";
import ClientSessions from "../pages/reports/ClientSessions/ClientSessions";
import TitleAnalysis from "../pages/reports/TitleAnalysis/TitleAnalysis";
import AdminSessions from "../pages/reports/AdminSessions/AdminSessions";
import ViewClientActivity from "../pages/reports/ClientActivity/ViewClientActivity";
import AllLeads from "../pages/leadmanagement/allLeads.jsx";
import DashBoard from "../pages/dashboard/dashboard.jsx";
import ItemManage from "../pages/bidding/itemmanagement/itemmanagement";
import EditItem from "../pages/bidding/itemmanagement/edititem";
import BidsDashBoard from "../pages/bidding/itemmanagement/bidsdashboard";
import BiddingLookUp from "../pages/bidding/biddinglookups/biddingLookup";
import Test from "../pages/bidding/test";
import EditBiddingLookUp from "../pages/bidding/biddinglookups/editlookup";
import ViewBiddingLookUp from "../pages/bidding/biddinglookups/viewbiddinglookup";
import BiddingTerms from "../pages/bidding/biddingterms";
import ViewTitleBids from "../pages/bidding/itemmanagement/viewTitleBids";
import AllBids from "../pages/bidding/bids/bids";
import ViewBidsSummary from "../pages/bidding/bids/bidssummary";
import ViewItem from "../pages/bidding/itemmanagement/viewitem";
import EditItemV2 from "../pages/bidding/itemmanagement/edititemV2";
import LeadReports from "../pages/reports/LeadReports/leadReports.jsx";
import News from "../pages/news/news.jsx";
import EditNews from "../pages/news/editNews.jsx";
import ClientCart from "../pages/reports/clientCart/clientCart.jsx";
import ViewCart from "../pages/reports/clientCart/viewCart.jsx";
import WelcomeMessage from "../pages/frontendSettings/welcomeMessage.jsx";
import ViewWelcomeMessage from "../pages/frontendSettings/viewWelcomeMessage.jsx";
import ViewClientSessions from "../pages/reports/ClientSessions/ViewClientSessions.jsx";
import ClientEnquiry from "../pages/reports/ClientEnquery/clientEnquiry.jsx";
import ViewClientEnquiry from "../pages/reports/ClientEnquery/viewClientEnquiry.jsx";
import NewsLetters from "../pages/newsletters/newsLetters.jsx";
import EditNewsLetters from "../pages/newsletters/editNewsLetters.jsx";
import RegisteredUsers from "../pages/registeredusers/registeredUsers.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/dashboard" element={<DashBoard />} />
      <Route path="/createpassword" element={<CreatePassword />} />
      <Route path="/login" element={<SignIn />} />

      <Route path="/company" element={<Company />} />
      <Route path="/editcompany/:id" element={<UpdateCompany />} />
      <Route path="/viewcompany/:id" element={<ViewCompany />} />
      <Route path="/addcompany" element={<UpdateCompany />} />

      <Route path="/clientsearch" element={<ClientSearch />} />
      <Route path="/leadsreports" element={<LeadReports />} />
      <Route path="/team" element={<Team />} />
      <Route path="/viewclientsearch/:id" element={<ViewClientSearch />} />

      <Route path="/recommended" element={<Recommend />} />
      <Route path="/emaillogs" element={<EmailLogs />} />
      <Route path="/contactus" element={<Contact />} />
      <Route path="/accountmanagers" element={<AMReport />} />
      <Route path="/videorequests" element={<VideoRequest />} />
      <Route path="/clientactivity" element={<ClientActivity />} />
      <Route path="/viewclientactivity/:id" element={<ViewClientActivity />} />
      <Route path="/clientsessions" element={<ClientSessions />} />
      <Route path="/adminsessions" element={<AdminSessions />} />
      <Route path="/titleanalysis" element={<TitleAnalysis />} />
      <Route path="/eventregisteredusers" element={<RegisteredUsers />} />

      <Route path="/categorymanagement" element={<Category />} />
      <Route path="/editcategory/:id" element={<EditCategory />} />
      <Route path="/viewcategory/:id" element={<ViewCategory />} />
      <Route path="/addcategory" element={<EditCategory />} />
      <Route path="/blockbuyer" element={<BlockBuyer />} />
      <Route path="/addblockbuyer" element={<EditBlockBuyer />} />
      <Route path="/editblockbuyer" element={<EditBlockBuyer />} />

      <Route path="/usermanagement" element={<UserManagement />} />
      <Route path="/createuser" element={<AddUser />} />
      <Route path="/adduser" element={<EditUser />} />
      <Route path="/edituser/:id" element={<EditUser />} />
      <Route path="/viewuser/:id" element={<ViewUser />} />

      <Route path="/contentmanagement" element={<ContentMange />} />
      <Route path="/contentupload" element={<ContentUpload />} />
      <Route path="/editcontent/:id" element={<EditContent />} />
      <Route path="/viewcontent/:id" element={<ViewContent />} />
      <Route path="/addcontent" element={<EditContent />} />
      <Route path="/contentmap" element={<MapContent />} />

      <Route path="/settings/:id" element={<AppConfig />} />

      <Route path="/dealmanagement" element={<AllDeals />} />
      <Route path="/leadmanagement" element={<AllLeads />} />
      <Route path="/editdeals/:id" element={<EditDeals />} />
      <Route path="/viewdeals/:id" element={<ViewDeals />} />
      <Route path="/createdeal" element={<AddDeals />} />

      <Route path="/frontendsettings" element={<FrontendSettings />} />
      <Route path="/landingpage" element={<LandingPage />} />
      <Route path="/advancedsearch" element={<AdvancedSettings />} />
      <Route path="/privacypolicy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/welcomemessage" element={<WelcomeMessage />} />
      <Route path="/viewwelcomemessage" element={<ViewWelcomeMessage />} />
      <Route path="/viewterms" element={<ViewTerms />} />
      <Route path="/viewprivacypolicy" element={<ViewPrivacy />} />
      <Route path="/viewteam" element={<ViewTeam />} />
      <Route path="/viewaboutus" element={<ViewAboutus />} />
      <Route path="/viewlandingpage" element={<ViewLandingPage />} />
      <Route path="/viewadvancedsearch" element={<ViewAdvancedSettings />} />
      <Route path="/aboutus" element={<Aboutus />} />

      <Route path="/profile" element={<Profile />} />
      <Route path="/changeCategoryOrder" element={<Changecategoryorder />} />

      <Route path="/news" element={<News />} />
      <Route path="/editnews/:id" element={<EditNews />} />
      <Route path="/addnews" element={<EditNews />} />


      <Route path="/newsletter" element={<NewsLetters />} />
      <Route path="/editnewsletter/:id" element={<EditNewsLetters />} /> 
      <Route path="/addnewsletter" element={<EditNewsLetters />} />


      <Route path="/clients" element={<Client />} />
      <Route path="/editclient/:id" element={<EditClient />} />
      <Route path="/viewclient/:id" element={<ViewClient />} />
      <Route path="/addclient" element={<EditClient />} />
      <Route path="/viewclientsessions/:id" element={<ViewClientSessions />} />
      <Route path="/additem" element={<EditItem />} />
      <Route path="/itemmanagement" element={<ItemManage />} />
      <Route path="/edititem/:id" element={<EditItem />} />
      <Route path="/edititemV1/:id" element={<EditItemV2 />} />
      <Route path="/viewitem/:id" element={<ViewItem />} />
      <Route path="/itembids/:id" element={<BidsDashBoard />} />
      <Route path="/biddinglookups" element={<BiddingLookUp />} />
      <Route path="/termsandconditions" element={<BiddingTerms />} />
      <Route path="/viewtitlebids/:id" element={<ViewTitleBids />} />
      <Route path="/test" element={<Test />} />
      <Route path="/clientcart" element={<ClientCart />} />
      <Route path="/viewcart/:id" element={<ViewCart />} />

      <Route path="/lookups" element={<LookUp />} />
      <Route path="/editlookup/:id" element={<EditLookUp />} />
      <Route path="/viewlookup/:id" element={<ViewLookUp />} />
      <Route path="/addlookup" element={<EditLookUp />} />

      <Route path="/bids" element={<AllBids />} />
      <Route path="/viewbidsummary/:id" element={<ViewBidsSummary />} />

      <Route path="/editbiddinglookup/:id" element={<EditBiddingLookUp />} />
      <Route path="/addbiddinglookup" element={<EditBiddingLookUp />} />
      <Route path="/viewbiddinglookup/:id" element={<ViewBiddingLookUp />} />

      <Route path="*" element={<NotFound />} />


      <Route path="/clientenquiry" element={<ClientEnquiry />} />
      <Route path="/viewclientenquiry/:id" element={<ViewClientEnquiry />} />
    </Routes>
  );
};

export default AppRoutes;
